import React from "react";
import BrokenStar from "../GlobalIcons/BrokenStar";
import Skeleton from "react-loading-skeleton";


function InlineWrapperWithMargin({ children }) {
  return <span style={{ marginRight: "0.5rem" }}>{children}</span>;
}
const ResultChip = ({
  name,
  detail,
  createFilterParams,
  item,
  handleOpenEvent,
  filterLoader,
}) => {
  return (
    <div
      className="chips_sec"
      onClick={() => {
        if (createFilterParams) {
          createFilterParams(item);
        }
        if (handleOpenEvent) {
          handleOpenEvent(item.event_id);
        }
      }}
    >
      {filterLoader === true ? (
        <Skeleton
          count={5}
          wrapper={InlineWrapperWithMargin}
          style={{ "--base-color": "#ccc", "--highlight-color": "#f5f5f5" }}
          height={25}
          inline
          width={90}
        />
      ) : (
        <div className="content_search">
          <div className="icon_search_cat">
            <BrokenStar />
          </div>
          <div className="content_head">
            <h5>{name}</h5>
            {detail && <p>{detail}</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default ResultChip;
